import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { gray, green, red } from '@ant-design/colors';
import {
	ClientOrder,
	ClientOrderPaymentState,
	getClientOrderColor,
	getReadableClientOrderPaymentState,
	getReadablePriceType,
	OrderType,
	PriceType,
} from 'types';
import { Timeline } from 'antd';
import { Formatting } from '../../utils';
import { AsyncLink } from '../../components/index';
import moment from 'moment';

interface Props {
	order: ClientOrder;
	container: { name: string } | undefined;
	payOrder: (id: number) => Promise<void>;
}

const getPaymentStateColor = (state: ClientOrderPaymentState) => {
	switch (state) {
		case ClientOrderPaymentState.overdue:
			return red[4];

		case ClientOrderPaymentState.paid:
			return green[4];

		case ClientOrderPaymentState.inProgress:
			return gray[5];

		default:
			return undefined;
	}
};

export const OrderTimelineItem: React.FC<Props> = ({ order, container, payOrder }) => {
	const icon = order.doneDate ? (
		<CheckCircleOutlined style={{ color: getClientOrderColor(order) }} />
	) : (
		<ClockCircleOutlined style={{ color: getClientOrderColor(order) }} />
	);

	const date = Formatting.epochToDate(order.date, moment(order.date).hours() === 0);
	const title = container ? `${order.address} - nr: ${container.name}` : order.address;
	const price = Formatting.money(order.priceType === PriceType.net ? order.netPrice : order.grossPrice);
	const priceType = getReadablePriceType(order.priceType);
	const paymentState = (
		<span style={{ color: getPaymentStateColor(order.paymentState) }}>
			{getReadableClientOrderPaymentState(order.paymentState)}
		</span>
	);
	const paymentAction =
		order.type === OrderType.classic && order.paymentState === ClientOrderPaymentState.overdue ? (
			<AsyncLink color={green[5]!} onClick={() => payOrder(order.id)}>
				Oznacz jako zapłacone
			</AsyncLink>
		) : undefined;
	const detailsAction = <Link to={`/panel/orders/${order.id}/${order.type}`}>Szczegóły</Link>;

	return (
		<Timeline.Item key={`${order.type}#${order.id}`} dot={icon}>
			<p>
				<span>{date}</span> - {title} • {price} {priceType} ({paymentState})
			</p>
			<p>
				{paymentAction}
				{paymentAction && ' • '}
				{detailsAction}
			</p>
		</Timeline.Item>
	);
};
